export default __webpack_public_path__ + "static/media/i (30).c25ca90f.jpg";